import React, { ReactNode} from 'react';
import { FormItemProps, Select, SelectProps, TooltipProps } from 'antd';
import { SelectValue } from 'antd/lib/select';
import { JInputWrapper } from '../JInputWrapper';

const { Option } = Select;

export type JSelectProps<VT extends SelectValue = SelectValue> = {
    /**
     * Action to update external module
     * @param value
     */
    onChange?: (value: number | string) => void;

    /**
     * label
     */
    label?: ReactNode;

    /**
     * name
     */
    name?: string | number | (string | number)[];

    /**
     * value
     */
    value?: number | string;

    /**
     * mode
     */
    mode?: ModeStatus[number];

    /**
     * defaultValue
     */
    defaultValue?: any;

    /**
     * placeholder
     */
    placeholder?: string;

    /**
     * List of options
     */
    options?: OptionDto[];

    /**
     * disabled
     */
    disabled?: boolean;

    /**
     * tooltip
     */
    tooltip?: ReactNode | (TooltipProps & { icon: ReactNode });

    /**
     * ant design Form.Item props
     * https://ant.design/components/form/#API
     */
    itemProps?: FormItemProps;

    /**
     * ant design Input props
     * https://ant.design/components/select/#API
     */
    selectProps?: SelectProps<VT>;
};

export type OptionDto = {
    id: number | string;
    label: string | ReactNode;
    labelTranslate?: string | ReactNode;
    className?: string;
    disabled?: boolean;
    title?: string;
    option?: any
};

export type ModeStatus = ['tags', 'multiple'];

export const JSelect: React.FC<JSelectProps<SelectValue>> = ({
                                                                 defaultValue,
                                                                 label,
                                                                 name,
                                                                 value,
                                                                 placeholder,
                                                                 mode,
                                                                 options,
                                                                 disabled = false,
                                                                 tooltip,
                                                                 onChange,
                                                                 itemProps,
                                                                 selectProps,
                                                             }) => {


    const handleChange = (value: any) => {
        if (onChange) {
            onChange(value);
        }
    };

    return (<>
            {label ? <JInputWrapper label={label} name={name} tooltip={tooltip} {...itemProps}>
                    <Select
                        mode={mode}
                        disabled={disabled}
                        placeholder={placeholder}
                        defaultValue={defaultValue}
                        value={value}
                        onChange={handleChange}
                        {...selectProps}
                    >
                        {options?.map((option) => (
                            <Option key={option.id} value={option.id} {...option}>
                                {option.label}
                            </Option>
                        ))}
                    </Select>
                </JInputWrapper> :
                <Select
                    mode={mode}
                    disabled={disabled}
                    placeholder={placeholder}
                    defaultValue={defaultValue}
                    value={value}
                    onChange={handleChange}
                    {...selectProps}
                >
                    {options?.map((option) => (
                        <Option key={option?.id} value={option?.id} {...option}>
                            {option?.labelTranslate || option?.label}
                        </Option>
                    ))}
                </Select>
            }</>
    );
};
